// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames not based on template
	if (chunkId === 517) return "static/chunks/517-60b0bd3e6a4922cb.js";
	if (chunkId === 839) return "static/chunks/839-f134f4fd0b918d32.js";
	// return url for filenames based on template
	return "static/chunks/" + ({"146":"datadog_browser_logs","340":"layout__client_site_chrome_ui","367":"layout__minimal","748":"datadog_browser_rum"}[chunkId] || chunkId) + "." + {"146":"28613d5d73bec73b","205":"142f13705c668700","319":"0cbc2894a3f1b950","340":"7bdd2d323c8ae591","367":"797dd23f999029ce","639":"0009326f588bf519","748":"aa5d4a33d02e1e74"}[chunkId] + ".js";
};